import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { IHealth } from 'src/types/health.type';

const healthSlice = createSlice<IHealth | null, SliceCaseReducers<IHealth | null>>({
  name: 'health',
  initialState: null,
  reducers: {
    setHealth: (state, { payload }: PayloadAction<IHealth | null>) => {
      return payload;
    },
  },
});

export const { setHealth } = healthSlice.actions;

export default healthSlice.reducer;
